import { render, staticRenderFns } from "./nationalInterest-edit.vue?vue&type=template&id=5318fd23&scoped=true&"
import script from "./nationalInterest-edit.vue?vue&type=script&lang=ts&"
export * from "./nationalInterest-edit.vue?vue&type=script&lang=ts&"
import style0 from "./nationalInterest-edit.vue?vue&type=style&index=0&id=5318fd23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5318fd23",
  null
  
)

export default component.exports